import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { local_routes } from 'utils/Routes';
import './style.css';
import axios from 'axios';
import { ButtonGroup, ToggleButton } from 'react-bootstrap';
import { apiUrl } from 'Api/Api';
import { assembleNickname } from 'utils/Helper';
import UserContext from 'store/UserContext';
import moment from 'moment';

function PechaKuchaUsersTable(props) {
  const context = UserContext;
  const [selected_access_level_option, setSelected_access_level_option] =
    useState();
  const [createdTime, setCreatedTime] = useState();
  const [radioValue, setRadioValue] = useState();
  const [settingStatus, setSettingStatus] = useState(false);
  const radios = [
    { name: 'Active', value: '1' },
    { name: 'Inactive', value: '2' },
    { name: 'Unverified', value: '3' }
  ];

  let workspace_base_url = '';
  if (props.workspace_base_url) {
    workspace_base_url = props.workspace_base_url;
  }

  useEffect(() => {
    if (!selected_access_level_option) {
      setSelected_access_level_option(props.userData.access_level_option);
      displayPrettyDate(props.userData.created_time);
      displayStatus(props.userData.status_code);
    }
  }, []);

  const displayPrettyDate = (timeData) => {
    let prettyDate = moment.unix(timeData).format('MM/DD/YYYY');
    return setCreatedTime(prettyDate);
  };
  async function displayStatus(value) {
    setSettingStatus(true);
    let statusPatch = {
      status_code: parseInt(value)
    };
    await axios.patch(
      `${apiUrl}users/${props.userData.entity_uuid}`,
      statusPatch
    );
    setRadioValue(value.toString());
    setSettingStatus(false);
  }

  return (
    <tr>
      <td style={{ fontSize: 'smaller' }}>
        {props.userData.entity_name || assembleNickname(props.userData)}
      </td>
      <td style={{ fontSize: 'smaller' }}>
        {props.userData.email || <em>hidden</em>}
      </td>
      <td style={{ fontSize: 'smaller' }}>
        <NavLink
          target="_blank"
          to={`${workspace_base_url}${local_routes.users}/${props.userData.friendly_url}`}>
          {props.userData.friendly_url}
        </NavLink>
      </td>
      <td>{createdTime}</td>
      <td style={{ fontSize: 'smaller' }}>
        <ButtonGroup toggle>
          {radios.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type="radio"
              variant={
                idx === 0
                  ? 'outline-success'
                  : idx === 1
                  ? 'outline-warning'
                  : 'outline-danger'
              }
              name="radio"
              value={radio.value}
              checked={radioValue === radio.value}
              onChange={(e) => displayStatus(e.currentTarget.value)}
              disabled={settingStatus}>
              {radio.name}
            </ToggleButton>
          ))}
        </ButtonGroup>
      </td>
    </tr>
  );
}
export default PechaKuchaUsersTable;
